export default __webpack_public_path__ + "static/okr-transparency-20a48f2c703df08287385c3b3a80e52d.webm";